module.exports = __webpack_public_path__ + "static/img/22Q3_NC_BigMotorSale.webp.0465961.webp";